import { render, staticRenderFns } from "./Monthly.vue?vue&type=template&id=be3aa1d8&scoped=true"
import script from "./Monthly.vue?vue&type=script&lang=js"
export * from "./Monthly.vue?vue&type=script&lang=js"
import style0 from "./Monthly.vue?vue&type=style&index=0&id=be3aa1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3aa1d8",
  null
  
)

export default component.exports